import React from "react";
import "./HomePage.css";
import YoutubeThumbnail from "../components/YoutubeThumbnail";

function LivePage() {
  return (
    <div className="home-page">
      <section className="container welcome-section">
        <h2>લાઇવ દર્શન</h2>
        <p className="main-description">
          લાઇવ દર્શન ને અહીંથી જુઓ. વિડિયો ચલાવવા માટે થંબનેલ પર ક્લિક કરો અથવા
          સીધા યુટ્યુબ પર ખોલો.
        </p>

        <div className="features">
          <div className="feature">
            <YoutubeThumbnail
              videoId="OgyyCrlHokk"
              title="Tarsara Parivar Live"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default LivePage;
